import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { HTTP_STATUSES } from "../../../../../utils/consts";
import { checkFilterItem, fetchFilterData } from "../../../../../utils/fetchFilterData";
import { itemsPerPageValue } from "../../../../../utils/ItemsPerPageValue";
import userAuthenticationConfig from "../../../../../utils/userAuthenticationConfig";
import { StyledDocumentWrapper } from "../../../../documents/styledDocument";
import ItemsPerPageSelect from "../../../../elements/filter/ItemsPerPageSelect";
import MaterialPagination from "../../../../styles/materialPagination";
import ClientFilter from "./ClientFilter";
import ClientList from "./ClientList";

const ClientListContainer = ({ t, serviceId, notification, setNotification }) => {

  const [clients, setClients] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "user.nickname": checkFilterItem(history, "user.nickname", null),
    "user.firstname": checkFilterItem(history, "user.firstname", null),
    "user.lastname": checkFilterItem(history, "user.lastname", null),
    "user.email": checkFilterItem(history, "user.email", null),
    "user.createDate[gte]": checkFilterItem(history, "user.createDate[gte]", null, true),
    "user.createDate[lte]": checkFilterItem(history, "user.createDate[lte]", null, true)
  });

  const getClients = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    filterUrl = fetchFilterData({
      ...filterData,
      "service.id": serviceId
    });

    axios.get("/api/user-services" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setClients(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  useEffect(() => {
    getClients();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <div className="services-details__client-list-head">
        <ClientFilter
          t={t}
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <ItemsPerPageSelect
          itemsPerPage={filterData.itemsPerPage}
          setItemsPerPage={(data) => setFilterData({
            ...filterData,
            "itemsPerPage": data,
            page: 1
          })}
        />
      </div>
      <ClientList
        t={t}
        clients={clients}
      />
      {totalPageCount &&
        <MaterialPagination
          count={totalPageCount}
          shape="rounded"
          page={filterData.page}
          onChange={(event, page) => onChangePage(event, page)}
        />}
    </>
  );
};

export default ClientListContainer;